// Interfaces
import { IRoute } from './route.interface'

// Webpage
import { webpageRoutes } from './webpage'

// Back Office
import { backOfficeChildrenRoutes } from './back-office'

// Auth
import { authRoutes } from './auth'

// Account
import { accountRoutes } from './account'

// Common
import { commonRoutes } from './common'

/**
 * @description Route list
 *
 * @note Make sure to put the route in order
 *
 * @note Webpage, Auth, Back Office, Common
 *
 * @return {IRoute[]} IRoute[]
 */
const routes: IRoute[] = [...webpageRoutes, ...authRoutes, ...accountRoutes, ...backOfficeChildrenRoutes, ...commonRoutes]

export { routes }
